












































import { defineComponent, PropType } from '@nuxtjs/composition-api';
import AppLink from '~/components/partials/App/AppLink.vue';
import { DynamicPartsContact } from '~/types/modules/contents';
import ActionMail from '~/assets/svg/icon_action-mail.svg?inline';
import ActionTel from '~/assets/svg/icon_action-tel.svg?inline';

export default defineComponent({
  components: {
    ActionTel,
    ActionMail,
    AppLink,
  },
  props: {
    item: {
      type: Object as PropType<DynamicPartsContact>,
      required: true,
    },
  },
  setup() {
    // お問い合わせがurlかemailかでデザインを出しわけする
    const isEmailType = (type: string) => {
      return type === 'email';
    };
    return { isEmailType };
  },
});
